import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FieldService } from '../../../../../../common/services/Field.service';
import * as _ from 'lodash';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: "ticket-field",
    templateUrl: './field.component.html',
    styleUrls: ['./field.css'],
    providers: [FieldService]
})

@Injectable()
export class FieldComponent implements OnInit {
    public modelFilter: any = {};
    public model: any = {};
    public user: any;
    public types: any = [];
    public type: any;
    public targets: any = [];
    public typeModal: string = 'add';

    public currentPage: number = 1;
    public totalRow: number = 0;
    public page_size: number = 10;
    totalItem: any = 0;
    totalPage: any = 0;
    public id_delete: number;
    public number: any = 0;

    public message: { class: string, content: string } = null;
    public modalRef: any = {};
    public modalRef2: any = {};

    public range: any = [];
    public row: any = [];
    public list: any = [];
    public data_options = [];
    public data_options_copy = [];

    constructor(
        private modalService: BsModalService,
        private fieldService : FieldService,
        private toastr: ToastrService
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
        this.types = [
            {
                text: '',
                id: ''
            },
            {
                text: 'Ký tự',
                id: 'text'
            },
            {
                text: 'Số',
                id: 'number'
            },
            {
                text: 'Ngày tháng',
                id: 'date'
            },
            {
                text: 'Văn bản',
                id: 'textarea'
            },
            {
                text: 'Chọn một phương án',
                id: 'select'
            },
            {
                text: 'Chọn nhiều phương án',
                id: 'multi-select'
            }
        ]
        for (let i = 0; i <= 30; i++) {
            this.range.push(i);
            this.row[i] = false;
        }
    }

    ngOnInit() {
        this.loadData({target: 'ticket'});
    }


    loadData(request: any = {}, sort: any = {}) {
        this.list = [];
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }

        this.fieldService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.list;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;


            } else {
                this.message = {
                    class: "alert dark alert-danger",
                    content: res.status + ' : ' + res.message
                };
                this.list = [];
            }

        }, err => {
            this.message = {
                class: "alert dark alert-danger",
                content: err.message
            };
            this.list = [];
        });
    }

    openModal(template: TemplateRef<any>, id?: any) {
        this.type = false;
        for (let i = 0; i <= 30; i++) {
            this.row[i] = false;
        }

        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template,config);

        this.model = {data:[]};
        this.typeModal = id ? 'edit' : 'add'

        if (id) {
            this.fieldService.find(id).subscribe(rs => {
                this.model = rs.data;
                this.type = this.model.type;
                this.data_options = rs.data.data;
                this.data_options_copy = Object.assign([], this.data_options);
                // if(this.model.type == 'select' || this.model.type == 'multi-select') {
                //     for(var i=0; i< this.model.data.length; i++) {
                //         this.row[i]= true;
                //     }
                // }
            })
        } else {
            this.data_options_copy = [""];
            this.data_options = [""];
        }
    }

    search() {
        this.currentPage = 1;
        if(this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
            this.loadData({title: this.modelFilter.keyword.trim(), target: 'ticket'});
        }else this.loadData({target: 'ticket'});
    }

    changedType($event) {
        for (let i = 0; i <= 30; i++) {
            this.row[i] = false;
        }

        this.row[0] = true;
        this.type = $event.value;
        this.model.type = $event.value;
        if(this.type != 'select' && this.type !='multi-select') {
            this.model.data = [];
        }
        if(this.typeModal == 'edit' && this.model.data) {
            for(var i=0; i< this.model.data.length; i++) {
                this.row[i]= true;
            }
        }
    }

    deleteOption(i) {
        // this.row[i] = false;
        this.data_options_copy.splice(i,1);
        this.data_options.splice(i,1);
    }
    addOption() {
        // this.number = this.number + 1;
        // this.row[this.number] = true;
        this.data_options_copy.push("");
        this.data_options.push("");
    }

    edit() {
        this.message = null;
        this.model.target = 'ticket';
        // if (!this.model.title || (this.model.title && this.model.title.trim() == ""))
        //     this.message = { class: "alert dark alert-danger", content: "Tiêu đề thuộc tính không được bỏ trống !" };
        // else if (!this.model.key || (this.model.key && this.model.key.trim() == "")) {
        //     this.message = { class: "alert dark alert-danger", content: "Key thuộc tính không được bỏ trống !" };
        // } else if (!this.model.type) {
        //     this.message = { class: "alert dark alert-danger", content: "Kiểu dữ liệu không được bỏ trống !" };
        // } else {
            this.model.key = this.model.key ?  this.model.key.replace(/ /g, '').toLowerCase(): "";
            this.model.title = this.model.title ? this.model.title.trim() : "";
            if(!/^[A-Za-z_]+$/gi.test(this.model.key)){
                this.message = { class: "alert dark alert-danger", content: "Key thuộc tính chỉ bao gồm chữ cái và dấu '_' !" };
                    setTimeout(() => this.message = null, 3000);
            } else if (this.model.type == 'select' || this.model.type == 'multi-select') {
                let data = [];
                let check = true;
                if(this.data_options_copy.length == 0){
                    this.message = { class: "alert dark alert-danger", content: "Phương án không được bỏ trống !" };
                    setTimeout(() => this.message = null, 3000);
                    check = false;
                } else {
                    for (var i = 0; i < this.data_options_copy.length; i++) {
                        $('#opt-' + i).css('border-color', '');
                        if (this.data_options[i].trim() == '') {
                            $('#opt-' + i).css("border-color", 'red');
                            check = false;
                        } else {
                            data.push(this.data_options[i].trim());
                        }
                    }
                }
                
                if (check) {
                    this.model.data = _.map(data,e=>{
                        if(e && e.trim() !='') return e;
                    });
                    let id = this.model._id;
                    // delete this.model._id;
                    this.fieldService.update(id, this.model).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                                this.toastr.error('Cập nhật thất bại', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                                this.toastr.success('Cập nhật thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                                
                                this.loadData({target: 'ticket'});
                                this.modalRef.hide();
                            }
                        }
                    }, error => {
                        this.message = { class: "alert dark alert-danger", content: error.message };
                        setTimeout(() => this.message = null, 3000);
                    });
                }
            }else {
                let id = this.model._id;
                    // delete this.model._id;
                    this.fieldService.update(id, this.model).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                            this.toastr.error('Cập nhật thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                            this.toastr.success('Cập nhật thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            
                            this.loadData({target: 'ticket'});
                            this.modalRef.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                    setTimeout(() => this.message = null, 3000);
                });
            }
        // }
    }
    add() {
        this.message = null;
        this.model.target = 'ticket';
        // if (!this.model.title)
        //     this.message = { class: "alert dark alert-danger", content: "Tiêu đề thuộc tính không được bỏ trống !" };
        // else if (!this.model.key) {
        //     this.message = { class: "alert dark alert-danger", content: "Key thuộc tính không được bỏ trống !" };
        // } else if (!this.model.type) {
        //     this.message = { class: "alert dark alert-danger", content: "Kiểu dữ liệu không được bỏ trống !" };
        // } else {
            this.model.key = this.model.key ?  this.model.key.replace(/ /g, '').toLowerCase(): "";
            this.model.title = this.model.title ? this.model.title.trim() : "";
            if(!/^[A-Za-z_]+$/gi.test(this.model.key)){
                this.message = { class: "alert dark alert-danger", content: "Key thuộc tính chỉ bao gồm chữ cái và dấu '_' !" };
                    setTimeout(() => this.message = null, 3000);
            } else if (this.model.type == 'select' || this.model.type == 'multi-select') {
                let data = [];
                let check = true;
                if(this.data_options_copy.length == 0){
                    this.message = { class: "alert dark alert-danger", content: "Phương án không được bỏ trống !" };
                    setTimeout(() => this.message = null, 3000);
                    check = false;
                } else {
                    for (var i = 0; i < this.data_options_copy.length; i++) {
                        $('#opt-' + i).css('border-color', '');
                        if (this.data_options[i].trim() == '') {
                            $('#opt-' + i).css("border-color", 'red');
                            check = false;
                        } else {
                            data.push(this.data_options[i].trim());
                        }
                    }
                }
                if (check) {
                    this.model.data = _.map(data,e=>{
                        if(e && e.trim() !='') return e;
                    });
                    this.fieldService.create(this.model).subscribe(res => {
                        if (res) {
                            let error = res.error;
                            if (error) {
                                this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                                this.toastr.error('Thêm mới thất bại', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                            } else {
                                this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                                this.toastr.success('Thêm mới thành công', '', {
                                    timeOut: 4000,
                                    positionClass: 'toast-bottom-right'
                                });
                                
                                this.loadData({target: 'ticket'});
                                this.modalRef.hide();
                            }
                        }
                    }, error => {
                        this.message = { class: "alert dark alert-danger", content: error.message };
                        setTimeout(() => this.message = null, 3000);
                    });
                }
            }else {
                this.fieldService.create(this.model).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                            this.toastr.error('Thêm mới thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                            this.toastr.success('Thêm mới thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            
                            this.loadData({target: 'ticket'});
                            this.modalRef.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                    setTimeout(() => this.message = null, 3000);
                });
            }
        // }

    }


    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDelete();
        }
    }

    submitDelete() {
        this.fieldService._delete(this.id_delete).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.message = { class: "alert dark alert-success", content: "Xóa thành công" };
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadData({target: 'ticket'});
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData({target: 'ticket'});
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData({target: 'ticket'});
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/ticket/field/field.component.ts